// RsaPathsContext.js — React context for the RSA multi-path / multi-lane system.
// Wrap the region that needs access with <RsaPathsContext.Provider value={rsaPathsHook}>.

import { createContext, useContext } from 'react';

export const RsaPathsContext = createContext(null);

/**
 * Access the RSA paths context from any child component.
 * Throws if used outside a RsaPathsContext.Provider.
 */
export function useRsaPathsContext() {
  const ctx = useContext(RsaPathsContext);
  if (!ctx) throw new Error('useRsaPathsContext must be used inside a RsaPathsContext.Provider');
  return ctx;
}
